import {ResourceTemplatePipe} from "./template/resource.template.pipe";
import {ResourceMediaPipe} from "./media/resource.media.pipe";
import {i18nModule} from "@config/i18n.module";
import {NgModule} from "@angular/core";
import {HttpModule} from "@angular/http";
import {CommonModule} from "@angular/common";
import {ResourcesModule} from "@resources/resources.module";
import {AutocompleteFixedDataComponent} from "./autocomplete/autocomplete.component";
import {ResourceMultimediaPipe} from "./image/resource.multimedia.pipe";
import {ResourceIconPipe} from "./icons/resource.icone.pipe";
// Form
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {DigiCerbaCommonModule} from "@digicerba/common";

/** liste des components / directive à exporter */
var sharedDeclaration: Array<any> = [
  ResourceMultimediaPipe, AutocompleteFixedDataComponent, ResourceTemplatePipe, ResourceMediaPipe, ResourceIconPipe
];

/** liste des modules à exporter */
var sharedModules: Array<any> = [
  FormsModule, ReactiveFormsModule, CommonModule, ResourcesModule, i18nModule
];

/** Liste des composants interne au module */
var declarations: Array<any> = [];

/** Liste des services */
var services: Array<any> = [];

/** Liste des composants necessitant la création d'une factory */
var entryComponents: Array<any> = [];

@NgModule({
  imports: [DigiCerbaCommonModule.forRoot(), HttpModule, ...sharedModules],
  declarations: [...sharedDeclaration, ...declarations, ...entryComponents],
  exports: [DigiCerbaCommonModule, ...sharedDeclaration, ...sharedModules],
  providers: services,
  entryComponents: entryComponents
})
export class UtilsModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/common/utils/utils.module.ts